// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/helpers.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_document.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("styles/img/icon_image.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("styles/img/icon_edit.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("styles/img/icon_edit_gray.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("styles/img/icon_close--gray.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__section___dvTQa {
}

.styles__sectionNoMargin___o8roc {
}

.styles__card___zwg9j {
}

.styles__cardMarginBot___NNlEX {
}

.styles__sectionSmall___SmxOB {
}

.styles__flexRow___r8Cxk {
}

.styles__tableSection___TPRkB {
  margin-bottom: 20px;
  padding-bottom: 10px;
}

.styles__button___Qjsww {
}

.styles__buttonLocal___f2OHz {
}

.styles__buttonSecondary___N1U2_ {
}

.styles__changeInvestmentButton___DFRQV {
  margin-top: 20px;
  margin-bottom: 10px;
}

.styles__resetSSN___NAgWp {
  height: 40px;
  line-height: 40px;
  margin-right: 20px;
}

.styles__blocks___WuQFQ {
  align-items: stretch;
  display: flex;
  flex-wrap: wrap;
}

.styles__block___kI8Wn {
  flex: 0 0 auto;
  margin: 0 1px 1px 0;
}

.styles__normal___E7PdW,
.styles__full___Y8FR2,
.styles__modal____Tk9T {
}

.styles__userInfo___gX9xN,
.styles__contactInfo___twzoJ,
.styles__addressInfo___yWjye,
.styles__investmentInfo___cWCYs,
.styles__relationshipInfo___R2OL6,
.styles__accountsInfo___naIwc {
}

.styles__normal___E7PdW .styles__userInfo___gX9xN {
    width: calc(100% * 1 / 2 - 1px);
  }

.styles__normal___E7PdW .styles__contactInfo___twzoJ {
    margin-right: 0;
    width: calc(100% * 1 / 2);
  }

.styles__full___Y8FR2 .styles__userInfo___gX9xN {
    width: calc(100% * 1 / 4 - 1px);
  }

.styles__full___Y8FR2 .styles__contactInfo___twzoJ {
    width: calc(100% * 1 / 4 - 1px);
  }

.styles__full___Y8FR2 .styles__addressInfo___yWjye {
    margin-right: 0;
    width: calc(100% * 1 / 2);
  }

.styles__modal____Tk9T .styles__userInfo___gX9xN {
    width: calc(100% * 1 / 5 - 1px);
  }

.styles__modal____Tk9T .styles__accountsInfo___naIwc {
    width: calc(100% * 2 / 5 - 1px);
  }

.styles__modal____Tk9T .styles__addressInfo___yWjye {
    margin-right: 0;
    width: calc(100% * 2 / 5);
  }

.styles__refTitle___pQ3Wl {
  display: inline-block;
  flex: 1;
}

.styles__refTitleRead___bBFbG {
  margin-bottom: 5px;
}

.styles__tabTitle___SWpVe {
  cursor: pointer;
  margin-right: 20px;
}

.styles__openTitle___QxcH2,
.styles__closedTitle___IY8u4 {
}

.styles__closedTitle___IY8u4 {
  opacity: 0.65;
}

.styles__rejectionTitleWrapper___cDgEX {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  color: white;
}

.styles__rejectionTitle___J5nAi {
  color: white;
}

.styles__rejectionBody____iwy5 {
  border-left: 4px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  margin-bottom: 20px;
}

.styles__row___O8Ee4 {
  margin-bottom: 10px;
}

.styles__row___O8Ee4:last-child {
    margin-bottom: 0;
  }

.styles__rowGroup___GW_7r {
  flex-direction: column;
}

.styles__rowGroup___GW_7r .styles__rowValue___Uk5fH {
    margin-top: 5px;
    width: 100%;
  }

.styles__label___ge8IV {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-size: 11px;
  margin-bottom: 3px;
}

.styles__error___p_035 {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
}

.styles__table___nrX6M {
  display: table;
  width: 100%;
}

.styles__thRow___tTkez {
  display: table-row;
}

.styles__tdRow___koHQ8 {
  display: table-row;
  -webkit-text-decoration: none;
  text-decoration: none;
}

.styles__tdCell____j9TX {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  display: table-cell;
  padding: 10px;
  vertical-align: top;
}

.styles__thCell___AkZbv {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-size: 12px;
}

.styles__tdDescriptionCell___KphYS {
  overflow-wrap: anywhere;
  color: #666;
}

.styles__tableNotes___kvfJ5 {
  max-height: 300px;
  overflow-y: auto;
  width: 100%;
}

.styles__tableNotes___kvfJ5 .styles__tdRow___koHQ8,
  .styles__tableNotes___kvfJ5 .styles__thRow___tTkez {
    display: block;
  }

.styles__tableNotes___kvfJ5 .styles__tdCell____j9TX,
  .styles__tableNotes___kvfJ5 .styles__thCell___AkZbv {
    display: inline-block;
  }

.styles__tableNotes___kvfJ5 .styles__tdCell____j9TX:nth-child(2),
    .styles__tableNotes___kvfJ5 .styles__thCell___AkZbv:nth-child(2),
    .styles__tableNotes___kvfJ5 .styles__tdCell____j9TX:nth-child(3),
    .styles__tableNotes___kvfJ5 .styles__thCell___AkZbv:nth-child(3) {
      width: calc(99.9% * 1/5 - (30px - 30px * 1/5));
    }

.styles__tableNotes___kvfJ5 .styles__tdCell____j9TX:nth-child(2):nth-child(1n),
    .styles__tableNotes___kvfJ5 .styles__thCell___AkZbv:nth-child(2):nth-child(1n),
    .styles__tableNotes___kvfJ5 .styles__tdCell____j9TX:nth-child(3):nth-child(1n),
    .styles__tableNotes___kvfJ5 .styles__thCell___AkZbv:nth-child(3):nth-child(1n) {
      float: left;
      margin-right: 30px;
      clear: none;
    }

.styles__tableNotes___kvfJ5 .styles__tdCell____j9TX:nth-child(2):last-child,
    .styles__tableNotes___kvfJ5 .styles__thCell___AkZbv:nth-child(2):last-child,
    .styles__tableNotes___kvfJ5 .styles__tdCell____j9TX:nth-child(3):last-child,
    .styles__tableNotes___kvfJ5 .styles__thCell___AkZbv:nth-child(3):last-child {
      margin-right: 0;
    }

.styles__tableNotes___kvfJ5 .styles__tdCell____j9TX:nth-child(2):nth-child(5n),
    .styles__tableNotes___kvfJ5 .styles__thCell___AkZbv:nth-child(2):nth-child(5n),
    .styles__tableNotes___kvfJ5 .styles__tdCell____j9TX:nth-child(3):nth-child(5n),
    .styles__tableNotes___kvfJ5 .styles__thCell___AkZbv:nth-child(3):nth-child(5n) {
      margin-right: 0;
      float: right;
    }

.styles__tableNotes___kvfJ5 .styles__tdCell____j9TX:nth-child(2):nth-child(5n + 1),
    .styles__tableNotes___kvfJ5 .styles__thCell___AkZbv:nth-child(2):nth-child(5n + 1),
    .styles__tableNotes___kvfJ5 .styles__tdCell____j9TX:nth-child(3):nth-child(5n + 1),
    .styles__tableNotes___kvfJ5 .styles__thCell___AkZbv:nth-child(3):nth-child(5n + 1) {
      clear: both;
    }

.styles__tableNotes___kvfJ5 .styles__tdCell____j9TX:nth-child(1), .styles__tableNotes___kvfJ5 .styles__thCell___AkZbv:nth-child(1) {
      width: calc(99.9% * 3/5 - (30px - 30px * 3/5));
    }

.styles__tableNotes___kvfJ5 .styles__tdCell____j9TX:nth-child(1):nth-child(1n), .styles__tableNotes___kvfJ5 .styles__thCell___AkZbv:nth-child(1):nth-child(1n) {
      float: left;
      margin-right: 30px;
      clear: none;
    }

.styles__tableNotes___kvfJ5 .styles__tdCell____j9TX:nth-child(1):last-child, .styles__tableNotes___kvfJ5 .styles__thCell___AkZbv:nth-child(1):last-child {
      margin-right: 0;
    }

.styles__tableNotes___kvfJ5 .styles__tdCell____j9TX:nth-child(1):nth-child(5n), .styles__tableNotes___kvfJ5 .styles__thCell___AkZbv:nth-child(1):nth-child(5n) {
      margin-right: 0;
      float: right;
    }

.styles__tableNotes___kvfJ5 .styles__tdCell____j9TX:nth-child(1):nth-child(5n + 1), .styles__tableNotes___kvfJ5 .styles__thCell___AkZbv:nth-child(1):nth-child(5n + 1) {
      clear: both;
    }

.styles__tableTickets___LJCny {
  max-height: 200px;
  overflow-y: auto;
}

.styles__docRow___yq4ZX {
  margin-bottom: 15px;
}

.styles__docLink___zYxeu,
.styles__imageLink___xE_yi {
  margin-left: 22px;
  position: relative;
  cursor: pointer;
}

.styles__docLink___zYxeu::before, .styles__imageLink___xE_yi::before {
    background-position: left center;
    background-repeat: no-repeat;
    background-size: 14px;
    bottom: 0;
    content: '';
    display: inline-block;
    height: 14px;
    left: -22px;
    margin: auto;
    position: absolute;
    top: 0;
    width: 22px;
  }

.styles__docLink___zYxeu::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.styles__imageLink___xE_yi::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.styles__docLabel___dODaI {
  margin-bottom: 3px;
}

.styles__pending___AYiAt,
.styles__incomplete___BI8T1 {
}

.styles__active___lqSv9,
.styles__approved___JZROq,
.styles__complete___uShK4 {
}

.styles__closed___ncjkD,
.styles__rejected___i5omP {
}

.styles__tableCollapseWrapper___pphSX .styles__tdRow___koHQ8 {
    cursor: pointer;
  }

.styles__tableCollapseWrapper___pphSX[data-active='true'] .styles__tdRow___koHQ8 {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreenLight"]};
  }

.styles__tableCollapseWrapper___pphSX[data-active='false'] .styles__tdRow___koHQ8 {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]};
  }

.styles__tableCollapseWrapper___pphSX[data-active='false'] .styles__tdRow___koHQ8:hover {
      background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreenLight"]};
    }

.styles__tableCollapseContent___clnv4 {
  background: rgba(218, 233, 232, 0.5);
  padding: 10px;
}

.styles__collapseIcon___UMvdZ {
}

.styles__collapseRef___pRmxg {
}

.styles__collapseRef___pRmxg[data-active='true'] .styles__collapseIcon___UMvdZ {
      transform: rotate(180deg);
    }

.styles__dropdownArea___JPwSF {
}

.styles__toggleLabel___bQJGG {
}

.styles__sectionTitle___JwRQV,
.styles__titleSection___TRQrk {
  position: relative;
}

.styles__sectionTitle___JwRQV:last-child, .styles__titleSection___TRQrk:last-child {
    margin-bottom: 20px;
  }

.styles__sectionTitle___JwRQV .styles__name___BE21D, .styles__titleSection___TRQrk .styles__name___BE21D {
    font-size: 18px;
    transition: all 0.25s;
  }

.styles__sectionTitle___JwRQV .styles__noName___g4Yp8, .styles__titleSection___TRQrk .styles__noName___g4Yp8 {
    margin-top: 2px;
  }

.styles__titleSectionLarge___o7ZFc {
  height: 72px;
}

.styles__titleSectionLargeNM___o7OFR {
}

.styles__titleSectionLargeNM___o7OFR:last-child {
    margin-bottom: 0;
  }

.styles__title___ngYeC {
  flex: 1;
}

.styles__contactType___dmvYj {
  font-size: 14px;
  padding: 4px 0;
}

.styles__contactType___dmvYj .styles__relationship___G4B2Q {
    font-weight: 300;
  }

.styles__contactEmailText___JBwql {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
  overflow-wrap: break-word;
  word-break: break-word;
}

.styles__contactEmailActionButton___OuRXK {
  align-items: center;
  background: white;
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]};
  border-radius: 3px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]};
  cursor: pointer;
  display: inline-flex;
  font-size: 12px;
  height: 32px;
  justify-content: center;
  min-width: 38px;
  -webkit-text-decoration: none;
  text-decoration: none;
}

.styles__contactEmailActionButton___OuRXK:hover {
  background-color: #f5f5f5;
}

.styles__contactEmailActionButton___OuRXK:active {
  background-color: #e8e8e8;
}

.styles__refEdit___bH3lY {
  background-position: center;
  background-repeat: no-repeat;
  background-size: 28px;
  border-radius: 3px;
  box-shadow: none;
  cursor: pointer;
  display: inline-block;
  height: 40px;
  transition: background-color 0.25s;
  width: 40px;
}

.styles__refEdit___bH3lY:hover {
    box-shadow: none;
    background-color: #e1dfe1;
  }

.styles__refEdit___bH3lY {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 18px;
}

.styles__refEditSmall___UAdl6 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: 13px;
  height: 30px;
  width: 30px;
}

.styles__noDocResults___tOqT8 {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
}

.styles__editLink___TGppv {
  position: absolute;
  right: 20px;
  top: 12px;
}

.styles__dodLink___Gkdiw {
  cursor: pointer;
}

.styles__dateStyle___FN8SS {
  padding: 0;
}

.styles__dateStyleClosed___XJ2Vo {
}

.styles__dateStyleClosed___XJ2Vo .styles__dateTitle___cUjv9 {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  }

.styles__dateStyleClosed___XJ2Vo .styles__dateTitle___cUjv9::before {
      background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
    }

.styles__dateStyleClosing___d3uTn {
}

.styles__dateStyleClosing___d3uTn .styles__dateTitle___cUjv9 {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]};
  }

.styles__dateStyleClosing___d3uTn .styles__dateTitle___cUjv9::before {
      background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]};
    }

.styles__dateStyleActive___wjAh6 {
}

.styles__dateStyleActive___wjAh6 .styles__dateTitle___cUjv9 {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
    padding: 10px;
  }

.styles__dateStyleActive___wjAh6 .styles__dateTitle___cUjv9::before {
      background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
    }

.styles__dateStylePending___hKDTO {
}

.styles__dateStylePending___hKDTO .styles__dateTitle___cUjv9 {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]};
  }

.styles__dateStylePending___hKDTO .styles__dateTitle___cUjv9::before {
      background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellow"]};
    }

.styles__dateStyleSuspended___WB63b {
}

.styles__dateStyleSuspended___WB63b .styles__dateTitle___cUjv9 {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]};
    padding: 10px;
  }

.styles__dateStyleSuspended___WB63b .styles__dateTitle___cUjv9::before {
      background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]};
    }

.styles__accountInfo___Rn1eH {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  height: 72px;
}

.styles__dateTitle___cUjv9 {
  height: 72px;
  font-weight: 500;
  justify-content: flex-end;
}

.styles__dateTitle___cUjv9::before {
    content: '';
    height: 10px;
    border-radius: 50%;
    margin-right: 10px;
    width: 10px;
  }

.styles__lastUpdated___fEtoh div.styles__row___O8Ee4 {
    font-size: 13px;
    margin-top: 4px;
    display: flex;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
    flex-direction: row;
    align-items: baseline;
  }

.styles__lastUpdated___fEtoh div.styles__row___O8Ee4 div.styles__label___ge8IV {
      margin-right: 5px;
      font-size: 13px;
    }

.styles__checkIcon___rDUZJ {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
}

.styles__timesIcon___oOU8W {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
}

.styles__dateInformation___jXxvV {
  height: 72px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColorLight"]};
}

.styles__dateInfoPending___JrGBL {
}

.styles__dateInfoPending___JrGBL::before {
    display: flex;
    align-self: center;
    margin-left: -20px;
    position: absolute;
    content: '';
    width: 4px;
    height: 72px;
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellow"]};
  }

.styles__dateInfoOpen___ixRWQ {
}

.styles__dateInfoOpen___ixRWQ::before {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  }

.styles__dateInfoClosed___GoYpr {
}

.styles__dateInfoClosed___GoYpr::before {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  }

.styles__dateInfoClosing___nG_5I {
}

.styles__dateInfoClosing___nG_5I::before {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]};
  }

.rgRow {
    display: flex;
    flex-direction: row;
    margin: 0 -10px;
    padding: 6px 10px;
  }

.rgLabel {
    color: #b6b6b6;
    display: inline-block;
    flex: 0.25;
    font-size: 12px;
    text-align: left;
  }

.rgValue {
    display: inline-block;
    flex: 0.75;
  }

.styles__fileName___rV9IU {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat left center;
  background-size: 20px;
  box-shadow: none;
  display: block;
  font-size: 18px;
  padding-left: 28px;
}

.styles__fileName___rV9IU:hover {
    box-shadow: none;
  }

.styles__accountExtrasSection___O9VPL {
  padding: 0;
}

.styles__singleLine___y9opj {
  display: flex;
  width: 100%;
  min-height: 40px;
  max-height: 100px;
  padding: 10px 20px;
  align-items: flex-start;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColorLight"]};
}

.styles__singleLine___y9opj div.styles__label___ge8IV {
    font-size: 14px;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
    opacity: 0.9;
    flex-shrink: 0;
    min-width: 120px;
    padding-top: 5px;
  }

.styles__rowError____qZkl {
}

.styles__rowError____qZkl .styles__value___TOakx,
  .styles__rowError____qZkl .styles__label___ge8IV {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  }

.styles__rowError____qZkl .styles__error___p_035 {
    font-weight: bold;
  }

.styles__valueMono___nWWmi {
  font-family: MaisonMono, monospace;
}

.styles__valueBlank___HSch3 {
  color: #eee;
}

.styles__valueBold___sw6SU {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]};
  font-weight: bold;
}

.styles__valueAlert___fOJbR {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  font-weight: bold;
}

.styles__noResults___CB4bl {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
}

.styles__notesSection____D_5Y {
  margin: 0;
}

.styles__formRefContent___NTnr_ {
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: relative;
}

.styles__formRefSection___O1xcg {
  flex: 0 0 30%;
  padding-right: 20px;
}

.styles__formRefSection___O1xcg:nth-child(2) {
    flex: 0 0 40%;
  }

.styles__formRefSection___O1xcg:nth-child(3) {
    flex: 0 0 30%;
    padding-right: 0;
  }

.styles__contactBasicFormRef___a0SRH {
  border-top: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]};
  margin-top: 20px;
  padding-top: 20px;
  position: relative;
}

.styles__contactBasicFormRef___a0SRH .styles__formRefContent___NTnr_ {
    display: flex;
    justify-content: space-between;
    width: 100%;
    position: relative;
  }

.styles__contactBasicFormRef___a0SRH .styles__formRefSection___O1xcg {
    flex: 0 0 30%;
    padding-right: 20px;
  }

.styles__contactBasicFormRef___a0SRH .styles__formRefSection___O1xcg:first-child {
      flex: 0 0 40%;
    }

.styles__contactBasicFormRef___a0SRH .styles__formRefSection___O1xcg:nth-child(2) {
      flex: 0 0 30%;
    }

.styles__contactBasicFormRef___a0SRH .styles__formRefSection___O1xcg:nth-child(3) {
      flex: 0 0 30%;
      padding-right: 0;
    }

.styles__formRefButtons___VuCG8 {
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  margin-bottom: 10px;
}

.styles__basicEdit___WL2_m {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 20px;
  border-radius: 3px;
  box-shadow: none;
  cursor: pointer;
  display: inline-block;
  height: 30px;
  margin-right: 20px;
  transition: all 0.25s;
  width: 30px;
}

.styles__basicEdit___WL2_m:hover {
    background-color: #e1dfe1;
    box-shadow: none;
  }

.styles__ticketFlag___z7OLh {
  display: inline-block;
  margin: 0;
  margin-left: -10px;
  margin-right: 10px;
  max-height: 40px;
  padding: 0;
}

.styles__ticketFlag___z7OLh img {
    margin: 0;
    max-height: 40px;
  }

.styles__ticketFlagSmall___QxIrr {
  float: right;
  margin: 0;
  max-height: 25px;
  padding: 0;
  width: 25px;
}

.styles__ticketFlagSmall___QxIrr img {
    max-height: 25px;
  }

.styles__buttons___K_f15 {
  align-items: center;
  display: flex;
  justify-content: flex-end;
}

.styles__removeBtn___X1a6g {
}

.styles__cancelBtn___oEOfV {
}

.styles__docsWrapper___L7pYM {
  background: white;
  border-radius: 0 0 3px 3px;
}

.styles__otherDocsRow___ZBgdx {
  align-content: center;
  height: 70px;
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]};
  align-items: center;
  padding: 0 20px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 100%;
}

.styles__otherDocsRow___ZBgdx:last-child {
    border: none;
  }

.styles__otherDocsRow___ZBgdx:hover div.styles__remove___bC2YH {
      opacity: 1;
    }

.styles__remove___bC2YH {
  opacity: 0;
  height: 20px;
  width: 20px;
  background-position: center;
  background-size: 14px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  cursor: pointer;
  transition: opacity 0.2s;
}

.styles__remove___bC2YH a {
    display: block;
    box-shadow: none;
    height: 20px;
    width: 20px;
  }

.styles__select___qWiFF {
  height: 30px;
}

.styles__spacer___L79sN {
  display: inline-block;
  width: 1em;
}

.styles__globalErrors___kqAwm {
  margin-bottom: 20px;
}

.styles__globalErrors___kqAwm h4 {
    margin-bottom: 10px;
  }

.styles__oneHalf___iwu2p {
  width: calc(99.9% * 1/2 - (30px - 30px * 1/2));
}

.styles__oneHalf___iwu2p:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__oneHalf___iwu2p:last-child {
  margin-right: 0;
}

.styles__oneHalf___iwu2p:nth-child(2n) {
  margin-right: 0;
  float: right;
}

.styles__oneHalf___iwu2p:nth-child(2n + 1) {
  clear: both;
}

.styles__flexFlow___T2DHT {
  flex-flow: wrap;
}

.styles__metric___oQhge {
  width: 50%;
  padding-bottom: 10px;
}

.styles__receiptButton___ZPMl_ {
  cursor: pointer;
}

.styles__receiptButton___ZPMl_ :hover {
    color: gray;
  }

.styles__infoButton___S7e82 {
  cursor: pointer;
  float: left;
  margin-left: 10px;
}

.styles__infoButton___S7e82 :hover {
    color: gray;
  }

.styles__input___MfLX9 {
}

.styles__formItemMono___bcb3G {
}

.styles__balanceRefHeader___bExfc {
  display: flex;
  align-items: center;
  width: 100%;
}

.styles__addSubaccountButton___IQjfh {
  margin-left: auto;
  padding: 8px 12px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: #4a6fba;
  font-weight: bold;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.styles__addSubaccountIcon___FWCNR {
  color: #4a6fba;
  font-size: 28px;
  font-weight: bold;
  margin-right: 12px;
  line-height: 14px;
}

.styles__singleLineValue___Byjo0 {
  flex: 1;
  text-align: right;
  margin-left: 20px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-height: 80px;
  overflow-y: auto;
  line-height: 1.4;
}

.styles__contactListPhone___zSd7h {
  display: flex;
  gap: 6px;
}

.styles__contactListWrapper___nLKlo {
  width: 100%;
}

.styles__contactListWrapper___nLKlo [class*='table'] {
  table-layout: fixed !important;
  width: 100% !important;
}

.styles__contactListWrapper___nLKlo [class*='tdCell']:nth-child(1),
.styles__contactListWrapper___nLKlo [class*='thCell']:nth-child(1) {
  width: 20% !important;
  word-break: break-word;
  overflow-wrap: break-word;
}

.styles__contactListWrapper___nLKlo [class*='tdCell']:nth-child(2),
.styles__contactListWrapper___nLKlo [class*='thCell']:nth-child(2) {
  width: 22% !important;
}

.styles__contactListWrapper___nLKlo [class*='tdCell']:nth-child(3),
.styles__contactListWrapper___nLKlo [class*='thCell']:nth-child(3) {
  width: 18% !important;
  word-break: break-word;
  overflow-wrap: break-word;
}

.styles__contactListWrapper___nLKlo [class*='tdCell']:nth-child(4),
.styles__contactListWrapper___nLKlo [class*='thCell']:nth-child(4) {
  width: 40% !important;
  overflow: hidden;
  word-break: break-word;
  overflow-wrap: break-word;
}
`, "",{"version":3,"sources":["webpack://./universal/components/References/styles.css"],"names":[],"mappings":"AAIA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EAEE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EAEE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,eAAe;AACjB;;AAEA;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;AAIA;;AAEA;;;;;;AAOA;;AAGE;IACE,+BAA+B;EACjC;;AAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;;AAIA;IACE,+BAA+B;EACjC;;AAEA;IACE,+BAA+B;EACjC;;AAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;;AAIA;IACE,+BAA+B;EACjC;;AAEA;IACE,+BAA+B;EACjC;;AAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;;AAGF;EACE,qBAAqB;EACrB,OAAO;AACT;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;AAGA;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wDAAiB;EACjB,YAAY;AAEd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mEAA4B;EAE5B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AAKrB;;AAHE;IACE,gBAAgB;EAClB;;AAGF;EACE,sBAAsB;AAMxB;;AAJE;IACE,eAAe;IACf,WAAW;EACb;;AAGF;EACE,oDAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mDAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,6BAAqB;EAArB,qBAAqB;AACvB;;AAEA;EACE,mDAAc;EAEd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oDAAgB;EAEhB,eAAe;AACjB;;AAEA;EAEE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AAoBb;;AAlBE;;IAEE,cAAc;EAChB;;AAEA;;IAEE,qBAAqB;EAUvB;;AARE;;;;MAEE,8CAAgB;IAClB;;AAHA;;;;MAEE,WAAgB;MAAhB,kBAAgB;MAAhB,WAAgB;IAClB;;AAHA;;;;MAEE,eAAgB;IAClB;;AAHA;;;;MAEE,eAAgB;MAAhB,YAAgB;IAClB;;AAHA;;;;MAEE,WAAgB;IAClB;;AAEA;MACE,8CAAgB;IAClB;;AAFA;MACE,WAAgB;MAAhB,kBAAgB;MAAhB,WAAgB;IAClB;;AAFA;MACE,eAAgB;IAClB;;AAFA;MACE,eAAgB;MAAhB,YAAgB;IAClB;;AAFA;MACE,WAAgB;IAClB;;AAIJ;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AAgBjB;;AAdE;IACE,gCAAgC;IAChC,4BAA4B;IAC5B,qBAAqB;IACrB,SAAS;IACT,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,WAAW;EACb;;AAGF;EACE,yDAAqD;AACvD;;AAEA;EACE,yDAAkD;AACpD;;AAEA;EAEE,kBAAkB;AACpB;;AAEA;;AAGA;;AAEA;;;AAIA;;AAEA;;AAGA;;AAGE;IACE,eAAe;EACjB;;AAEA;IACE,yDAAwB;EAC1B;;AAEA;IACE,wDAAuB;EAKzB;;AAHE;MACE,yDAAwB;IAC1B;;AAIJ;EACE,oCAAoC;EAEpC,aAAa;AACf;;AAEA;AAEA;;AAEA;AAQA;;AAJI;MACE,yBAAyB;IAC3B;;AAIJ;AAEA;;AAEA;AAEA;;AAEA;;EAGE,kBAAkB;AAcpB;;AAZE;IACE,mBAAmB;EACrB;;AAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;AAEA;IACE,eAAe;EACjB;;AAGF;EAEE,YAAY;AACd;;AAEA;AAMA;;AAHE;IACE,gBAAgB;EAClB;;AAGF;EACE,OAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;AAKhB;;AAHE;IACE,gBAAgB;EAClB;;AAGF;EACE,oDAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,8DAA6B;EAC7B,kBAAkB;EAClB,mDAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,6BAAqB;EAArB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,kCAAkC;EAClC,WAAW;AAMb;;AAJE;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;AAGF;EACE,yDAAiD;EACjD,qBAAqB;AACvB;;AAEA;EAEE,yDAAsD;EACtD,qBAAqB;EACrB,YAAY;EACZ,WAAW;AACb;;AAEA;EAEE,oDAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;AAUA;;AAPE;IACE,mDAAY;EAKd;;AAHE;MACE,wDAAiB;IACnB;;AAIJ;AAUA;;AAPE;IACE,oDAAmB;EAKrB;;AAHE;MACE,yDAAwB;IAC1B;;AAIJ;AAWA;;AARE;IACE,mDAAc;IACd,aAAa;EAKf;;AAHE;MACE,wDAAmB;IACrB;;AAIJ;AAUA;;AAPE;IACE,oDAAmB;EAKrB;;AAHE;MACE,yDAAoB;IACtB;;AAIJ;AAWA;;AARE;IACE,oDAAmB;IACnB,aAAa;EAKf;;AAHE;MACE,yDAAwB;IAC1B;;AAIJ;EAEE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EAEE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAS3B;;AAPE;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;EACb;;AAIA;IACE,eAAe;IACf,eAAe;IACf,aAAa;IACb,oDAAgB;IAChB,mBAAmB;IACnB,qBAAqB;EAMvB;;AAJE;MACE,iBAAiB;MACjB,eAAe;IACjB;;AAIJ;EACE,mDAAc;AAChB;;AAEA;EACE,mDAAY;AACd;;AAEA;EAEE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,qEAAyC;AAC3C;;AAEA;AAaA;;AAVE;IACE,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,yDAAoB;EACtB;;AAGF;AAMA;;AAHE;IACE,wDAAmB;EACrB;;AAGF;AAMA;;AAHE;IACE,wDAAiB;EACnB;;AAGF;AAMA;;AAHE;IACE,yDAAwB;EAC1B;;AAIA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;;AAEA;IACE,cAAc;IACd,qBAAqB;IACrB,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;;AAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;AAGF;EACE,yEAAqE;EACrE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AAKpB;;AAHE;IACE,gBAAgB;EAClB;;AAGF;EAEE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,qEAAyC;AAU3C;;AARE;IACE,eAAe;IACf,oDAAW;IACX,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,gBAAgB;EAClB;;AAGF;AAWA;;AARE;;IAEE,mDAAY;EACd;;AAEA;IACE,iBAAiB;EACnB;;AAGF;EAEE,kCAAkC;AACpC;;AAEA;EACE,WAAW;AAEb;;AAEA;EACE,mDAAiB;EAEjB,iBAAiB;AACnB;;AAEA;EACE,mDAAY;EAEZ,iBAAiB;AACnB;;AAEA;EACE,oDAAgB;AAElB;;AAEA;EAEE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AAUrB;;AARE;IACE,aAAa;EACf;;AAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;AAGF;EACE,kEAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AA0BpB;;AAxBE;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;EACpB;;AAEA;IACE,aAAa;IACb,mBAAmB;EAcrB;;AAZE;MACE,aAAa;IACf;;AAEA;MACE,aAAa;IACf;;AAEA;MACE,aAAa;MACb,gBAAgB;IAClB;;AAIJ;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8DAAwB;EACxB,yDAAiD;EACjD,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AAMb;;AAJE;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;AAGF;EACE,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AAMZ;;AAJE;IACE,SAAS;IACT,gBAAgB;EAClB;;AAGF;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,WAAW;AAKb;;AAHE;IACE,gBAAgB;EAClB;;AAGF;EACE,mBAAmB;EAEnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EAEE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,qEAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;AAWb;;AATE;IACE,YAAY;EACd;;AAGE;MACE,UAAU;IACZ;;AAIJ;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,qBAAqB;EACrB,4BAA4B;EAC5B,yDAAwD;EACxD,eAAe;EACf,wBAAwB;AAQ1B;;AANE;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;;AAGF;EAEE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EAEE,mBAAmB;AAKrB;;AAHE;IACE,mBAAmB;EACrB;;AAGF;EACE,8CAAkB;AACpB;;AAFA;EACE,WAAkB;EAAlB,kBAAkB;EAAlB,WAAkB;AACpB;;AAFA;EACE,eAAkB;AACpB;;AAFA;EACE,eAAkB;EAAlB,YAAkB;AACpB;;AAFA;EACE,WAAkB;AACpB;;AAEA;EAEE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,eAAe;AAKjB;;AAHE;IACE,WAAW;EACb;;AAGF;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AAKnB;;AAHE;IACE,WAAW;EACb;;AAGF;AAEA;;AAEA;AAEA;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtGrayLight, gtCardHeaderBG, borderColor, borderColorLight, gtGray, gtGrayDark, gtRed, gtBlueDark, gtBlueLight, gtGreen, gtGreenLight, gtYellowDark, gtYellow, gtYellowLight, text, textLight from colors;\n\n.section {\n  composes: section from helpers;\n}\n\n.sectionNoMargin {\n  composes: sectionNoMargin from helpers;\n}\n\n.card {\n  composes: card from helpers;\n}\n\n.cardMarginBot {\n  composes: cardMarginBot from helpers;\n}\n\n.sectionSmall {\n  composes: sectionSmall from helpers;\n}\n\n.flexRow {\n  composes: flexRow from helpers;\n}\n\n.tableSection {\n  composes: section;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n}\n\n.button {\n  composes: button from helpers;\n}\n\n.buttonLocal {\n  composes: buttonLocal from helpers;\n}\n\n.buttonSecondary {\n  composes: buttonSecondary from helpers;\n}\n\n.changeInvestmentButton {\n  composes: button from helpers;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n\n.resetSSN {\n  composes: buttonSecondary;\n  height: 40px;\n  line-height: 40px;\n  margin-right: 20px;\n}\n\n.blocks {\n  align-items: stretch;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.block {\n  composes: section from helpers;\n  flex: 0 0 auto;\n  margin: 0 1px 1px 0;\n}\n\n.normal,\n.full,\n.modal {\n  composes: blocks;\n}\n\n.userInfo,\n.contactInfo,\n.addressInfo,\n.investmentInfo,\n.relationshipInfo,\n.accountsInfo {\n  composes: block;\n}\n\n.normal {\n  .userInfo {\n    width: calc(100% * 1 / 2 - 1px);\n  }\n\n  .contactInfo {\n    margin-right: 0;\n    width: calc(100% * 1 / 2);\n  }\n}\n\n.full {\n  .userInfo {\n    width: calc(100% * 1 / 4 - 1px);\n  }\n\n  .contactInfo {\n    width: calc(100% * 1 / 4 - 1px);\n  }\n\n  .addressInfo {\n    margin-right: 0;\n    width: calc(100% * 1 / 2);\n  }\n}\n\n.modal {\n  .userInfo {\n    width: calc(100% * 1 / 5 - 1px);\n  }\n\n  .accountsInfo {\n    width: calc(100% * 2 / 5 - 1px);\n  }\n\n  .addressInfo {\n    margin-right: 0;\n    width: calc(100% * 2 / 5);\n  }\n}\n\n.refTitle {\n  display: inline-block;\n  flex: 1;\n}\n\n.refTitleRead {\n  margin-bottom: 5px;\n}\n\n.tabTitle {\n  composes: refTitle;\n  cursor: pointer;\n  margin-right: 20px;\n}\n\n.openTitle,\n.closedTitle {\n  composes: tabTitle;\n}\n\n.closedTitle {\n  opacity: 0.65;\n}\n\n.rejectionTitleWrapper {\n  background: gtRed;\n  color: white;\n  composes: sectionTitle from helpers;\n}\n\n.rejectionTitle {\n  color: white;\n}\n\n.rejectionBody {\n  border-left: 4px solid gtRed;\n  composes: section from helpers;\n  margin-bottom: 20px;\n}\n\n.row {\n  margin-bottom: 10px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.rowGroup {\n  flex-direction: column;\n\n  .rowValue {\n    margin-top: 5px;\n    width: 100%;\n  }\n}\n\n.label {\n  color: textLight;\n  font-size: 11px;\n  margin-bottom: 3px;\n}\n\n.error {\n  color: gtRed;\n}\n\n.table {\n  display: table;\n  width: 100%;\n}\n\n.thRow {\n  display: table-row;\n}\n\n.tdRow {\n  display: table-row;\n  text-decoration: none;\n}\n\n.tdCell {\n  color: gtGreen;\n  composes: clearfix from helpers;\n  display: table-cell;\n  padding: 10px;\n  vertical-align: top;\n}\n\n.thCell {\n  color: textLight;\n  composes: tdCell;\n  font-size: 12px;\n}\n\n.tdDescriptionCell {\n  composes: tdCell;\n  overflow-wrap: anywhere;\n  color: #666;\n}\n\n.tableNotes {\n  max-height: 300px;\n  overflow-y: auto;\n  width: 100%;\n\n  .tdRow,\n  .thRow {\n    display: block;\n  }\n\n  .tdCell,\n  .thCell {\n    display: inline-block;\n\n    &:nth-child(2),\n    &:nth-child(3) {\n      lost-column: 1/5;\n    }\n\n    &:nth-child(1) {\n      lost-column: 3/5;\n    }\n  }\n}\n\n.tableTickets {\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.docRow {\n  composes: row;\n  margin-bottom: 15px;\n}\n\n.docLink,\n.imageLink {\n  margin-left: 22px;\n  position: relative;\n  cursor: pointer;\n\n  &::before {\n    background-position: left center;\n    background-repeat: no-repeat;\n    background-size: 14px;\n    bottom: 0;\n    content: '';\n    display: inline-block;\n    height: 14px;\n    left: -22px;\n    margin: auto;\n    position: absolute;\n    top: 0;\n    width: 22px;\n  }\n}\n\n.docLink::before {\n  background-image: url('styles/img/icon_document.png');\n}\n\n.imageLink::before {\n  background-image: url('styles/img/icon_image.png');\n}\n\n.docLabel {\n  composes: label;\n  margin-bottom: 3px;\n}\n\n.pending,\n.incomplete {\n  composes: statusPending from helpers;\n}\n\n.active,\n.approved,\n.complete {\n  composes: statusActive from helpers;\n}\n\n.closed,\n.rejected {\n  composes: statusRejected from helpers;\n}\n\n.tableCollapseWrapper {\n  .tdRow {\n    cursor: pointer;\n  }\n\n  &[data-active='true'] .tdRow {\n    background: gtGreenLight;\n  }\n\n  &[data-active='false'] .tdRow {\n    background: gtGrayLight;\n\n    &:hover {\n      background: gtGreenLight;\n    }\n  }\n}\n\n.tableCollapseContent {\n  background: rgba(218, 233, 232, 0.5);\n  composes: clearfix from helpers;\n  padding: 10px;\n}\n\n.collapseIcon {\n  composes: collapseIcon from helpers;\n}\n\n.collapseRef {\n  composes: collapseRef from helpers;\n\n  &[data-active='true'] {\n    .collapseIcon {\n      transform: rotate(180deg);\n    }\n  }\n}\n\n.dropdownArea {\n  composes: dropdownArea from helpers;\n}\n\n.toggleLabel {\n  composes: toggleLabel from helpers;\n}\n\n.sectionTitle,\n.titleSection {\n  composes: sectionTitle row from helpers;\n  position: relative;\n\n  &:last-child {\n    margin-bottom: 20px;\n  }\n\n  .name {\n    font-size: 18px;\n    transition: all 0.25s;\n  }\n\n  .noName {\n    margin-top: 2px;\n  }\n}\n\n.titleSectionLarge {\n  composes: titleSection;\n  height: 72px;\n}\n\n.titleSectionLargeNM {\n  composes: titleSectionLarge;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.title {\n  flex: 1;\n}\n\n.contactType {\n  font-size: 14px;\n  padding: 4px 0;\n\n  .relationship {\n    font-weight: 300;\n  }\n}\n\n.contactEmailText {\n  color: text;\n  overflow-wrap: break-word;\n  word-break: break-word;\n}\n\n.contactEmailActionButton {\n  align-items: center;\n  background: white;\n  border: 1px solid gtBlueLight;\n  border-radius: 3px;\n  color: gtGrayDark;\n  cursor: pointer;\n  display: inline-flex;\n  font-size: 12px;\n  height: 32px;\n  justify-content: center;\n  min-width: 38px;\n  text-decoration: none;\n}\n\n.contactEmailActionButton:hover {\n  background-color: #f5f5f5;\n}\n\n.contactEmailActionButton:active {\n  background-color: #e8e8e8;\n}\n\n.refEdit {\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 28px;\n  border-radius: 3px;\n  box-shadow: none;\n  cursor: pointer;\n  display: inline-block;\n  height: 40px;\n  transition: background-color 0.25s;\n  width: 40px;\n\n  &:hover {\n    box-shadow: none;\n    background-color: #e1dfe1;\n  }\n}\n\n.refEdit {\n  background-image: url('styles/img/icon_edit.png');\n  background-size: 18px;\n}\n\n.refEditSmall {\n  composes: refEdit;\n  background-image: url('styles/img/icon_edit_gray.png');\n  background-size: 13px;\n  height: 30px;\n  width: 30px;\n}\n\n.noDocResults {\n  composes: sectionNoMargin;\n  color: textLight;\n}\n\n.editLink {\n  position: absolute;\n  right: 20px;\n  top: 12px;\n}\n\n.dodLink {\n  cursor: pointer;\n}\n\n.dateStyle {\n  padding: 0;\n}\n\n.dateStyleClosed {\n  composes: dateStyle;\n\n  .dateTitle {\n    color: gtRed;\n\n    &::before {\n      background: gtRed;\n    }\n  }\n}\n\n.dateStyleClosing {\n  composes: dateStyle;\n\n  .dateTitle {\n    color: gtYellowDark;\n\n    &::before {\n      background: gtYellowDark;\n    }\n  }\n}\n\n.dateStyleActive {\n  composes: dateStyle;\n\n  .dateTitle {\n    color: gtGreen;\n    padding: 10px;\n\n    &::before {\n      background: gtGreen;\n    }\n  }\n}\n\n.dateStylePending {\n  composes: dateStyle;\n\n  .dateTitle {\n    color: gtYellowDark;\n\n    &::before {\n      background: gtYellow;\n    }\n  }\n}\n\n.dateStyleSuspended {\n  composes: dateStyle;\n\n  .dateTitle {\n    color: gtYellowDark;\n    padding: 10px;\n\n    &::before {\n      background: gtYellowDark;\n    }\n  }\n}\n\n.accountInfo {\n  composes: sectionTitle from helpers;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  width: 100%;\n  height: 72px;\n}\n\n.dateTitle {\n  composes: sectionTitle from helpers;\n  height: 72px;\n  font-weight: 500;\n  justify-content: flex-end;\n\n  &::before {\n    content: '';\n    height: 10px;\n    border-radius: 50%;\n    margin-right: 10px;\n    width: 10px;\n  }\n}\n\n.lastUpdated {\n  div.row {\n    font-size: 13px;\n    margin-top: 4px;\n    display: flex;\n    color: textLight;\n    flex-direction: row;\n    align-items: baseline;\n\n    div.label {\n      margin-right: 5px;\n      font-size: 13px;\n    }\n  }\n}\n\n.checkIcon {\n  color: gtGreen;\n}\n\n.timesIcon {\n  color: gtRed;\n}\n\n.dateInformation {\n  composes: sectionNoMargin;\n  height: 72px;\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid borderColorLight;\n}\n\n.dateInfoPending {\n  composes: dateInformation;\n\n  &::before {\n    display: flex;\n    align-self: center;\n    margin-left: -20px;\n    position: absolute;\n    content: '';\n    width: 4px;\n    height: 72px;\n    background: gtYellow;\n  }\n}\n\n.dateInfoOpen {\n  composes: dateInfoPending;\n\n  &::before {\n    background: gtGreen;\n  }\n}\n\n.dateInfoClosed {\n  composes: dateInfoPending;\n\n  &::before {\n    background: gtRed;\n  }\n}\n\n.dateInfoClosing {\n  composes: dateInfoPending;\n\n  &::before {\n    background: gtYellowDark;\n  }\n}\n\n:global {\n  .rgRow {\n    display: flex;\n    flex-direction: row;\n    margin: 0 -10px;\n    padding: 6px 10px;\n  }\n\n  .rgLabel {\n    color: #b6b6b6;\n    display: inline-block;\n    flex: 0.25;\n    font-size: 12px;\n    text-align: left;\n  }\n\n  .rgValue {\n    display: inline-block;\n    flex: 0.75;\n  }\n}\n\n.fileName {\n  background: url('styles/img/icon_document.png') no-repeat left center;\n  background-size: 20px;\n  box-shadow: none;\n  display: block;\n  font-size: 18px;\n  padding-left: 28px;\n\n  &:hover {\n    box-shadow: none;\n  }\n}\n\n.accountExtrasSection {\n  composes: sectionNoMargin;\n  padding: 0;\n}\n\n.singleLine {\n  display: flex;\n  width: 100%;\n  min-height: 40px;\n  max-height: 100px;\n  padding: 10px 20px;\n  align-items: flex-start;\n  flex-direction: row;\n  justify-content: space-between;\n  border-bottom: 1px solid borderColorLight;\n\n  div.label {\n    font-size: 14px;\n    color: text;\n    opacity: 0.9;\n    flex-shrink: 0;\n    min-width: 120px;\n    padding-top: 5px;\n  }\n}\n\n.rowError {\n  composes: row;\n\n  .value,\n  .label {\n    color: gtRed;\n  }\n\n  .error {\n    font-weight: bold;\n  }\n}\n\n.valueMono {\n  composes: value;\n  font-family: MaisonMono, monospace;\n}\n\n.valueBlank {\n  color: #eee;\n  composes: value;\n}\n\n.valueBold {\n  color: gtBlueDark;\n  composes: value;\n  font-weight: bold;\n}\n\n.valueAlert {\n  color: gtRed;\n  composes: value;\n  font-weight: bold;\n}\n\n.noResults {\n  color: textLight;\n  composes: section from helpers;\n}\n\n.notesSection {\n  composes: section;\n  margin: 0;\n}\n\n.formRefContent {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  position: relative;\n}\n\n.formRefSection {\n  flex: 0 0 30%;\n  padding-right: 20px;\n\n  &:nth-child(2) {\n    flex: 0 0 40%;\n  }\n\n  &:nth-child(3) {\n    flex: 0 0 30%;\n    padding-right: 0;\n  }\n}\n\n.contactBasicFormRef {\n  border-top: 1px solid gtBlueLight;\n  margin-top: 20px;\n  padding-top: 20px;\n  position: relative;\n\n  .formRefContent {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    position: relative;\n  }\n\n  .formRefSection {\n    flex: 0 0 30%;\n    padding-right: 20px;\n\n    &:first-child {\n      flex: 0 0 40%;\n    }\n\n    &:nth-child(2) {\n      flex: 0 0 30%;\n    }\n\n    &:nth-child(3) {\n      flex: 0 0 30%;\n      padding-right: 0;\n    }\n  }\n}\n\n.formRefButtons {\n  position: absolute;\n  right: 0;\n  top: 0;\n  display: flex;\n  margin-bottom: 10px;\n}\n\n.basicEdit {\n  background-color: gtGray;\n  background-image: url('styles/img/icon_edit.png');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 20px;\n  border-radius: 3px;\n  box-shadow: none;\n  cursor: pointer;\n  display: inline-block;\n  height: 30px;\n  margin-right: 20px;\n  transition: all 0.25s;\n  width: 30px;\n\n  &:hover {\n    background-color: #e1dfe1;\n    box-shadow: none;\n  }\n}\n\n.ticketFlag {\n  display: inline-block;\n  margin: 0;\n  margin-left: -10px;\n  margin-right: 10px;\n  max-height: 40px;\n  padding: 0;\n\n  & img {\n    margin: 0;\n    max-height: 40px;\n  }\n}\n\n.ticketFlagSmall {\n  float: right;\n  margin: 0;\n  max-height: 25px;\n  padding: 0;\n  width: 25px;\n\n  & img {\n    max-height: 25px;\n  }\n}\n\n.buttons {\n  align-items: center;\n  composes: section from helpers;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.removeBtn {\n  composes: buttonDanger from helpers;\n}\n\n.cancelBtn {\n  composes: button from helpers;\n}\n\n.docsWrapper {\n  composes: flexColumn from helpers;\n  background: white;\n  border-radius: 0 0 3px 3px;\n}\n\n.otherDocsRow {\n  align-content: center;\n  height: 70px;\n  border-bottom: 1px solid borderColor;\n  align-items: center;\n  padding: 0 20px;\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  width: 100%;\n\n  &:last-child {\n    border: none;\n  }\n\n  &:hover {\n    div.remove {\n      opacity: 1;\n    }\n  }\n}\n\n.remove {\n  opacity: 0;\n  height: 20px;\n  width: 20px;\n  background-position: center;\n  background-size: 14px;\n  background-repeat: no-repeat;\n  background-image: url('styles/img/icon_close--gray.png');\n  cursor: pointer;\n  transition: opacity 0.2s;\n\n  a {\n    display: block;\n    box-shadow: none;\n    height: 20px;\n    width: 20px;\n  }\n}\n\n.select {\n  composes: select from helpers;\n  height: 30px;\n}\n\n.spacer {\n  display: inline-block;\n  width: 1em;\n}\n\n.globalErrors {\n  composes: error;\n  margin-bottom: 20px;\n\n  h4 {\n    margin-bottom: 10px;\n  }\n}\n\n.oneHalf {\n  lost-column: 1/2 2;\n}\n\n.flexFlow {\n  composes: flexRow from helpers;\n  flex-flow: wrap;\n}\n\n.metric {\n  width: 50%;\n  padding-bottom: 10px;\n}\n\n.receiptButton {\n  cursor: pointer;\n\n  :hover {\n    color: gray;\n  }\n}\n\n.infoButton {\n  cursor: pointer;\n  float: left;\n  margin-left: 10px;\n\n  :hover {\n    color: gray;\n  }\n}\n\n.input {\n  composes: input from helpers;\n}\n\n.formItemMono {\n  composes: formItemMono from helpers;\n}\n\n.balanceRefHeader {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.addSubaccountButton {\n  margin-left: auto;\n  padding: 8px 12px;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  color: #4a6fba;\n  font-weight: bold;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n}\n\n.addSubaccountIcon {\n  color: #4a6fba;\n  font-size: 28px;\n  font-weight: bold;\n  margin-right: 12px;\n  line-height: 14px;\n}\n\n.singleLineValue {\n  flex: 1;\n  text-align: right;\n  margin-left: 20px;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  max-height: 80px;\n  overflow-y: auto;\n  line-height: 1.4;\n}\n\n.contactListPhone {\n  display: flex;\n  gap: 6px;\n}\n\n.contactListWrapper {\n  width: 100%;\n}\n\n.contactListWrapper :global([class*='table']) {\n  table-layout: fixed !important;\n  width: 100% !important;\n}\n\n.contactListWrapper :global([class*='tdCell']:nth-child(1)),\n.contactListWrapper :global([class*='thCell']:nth-child(1)) {\n  width: 20% !important;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n\n.contactListWrapper :global([class*='tdCell']:nth-child(2)),\n.contactListWrapper :global([class*='thCell']:nth-child(2)) {\n  width: 22% !important;\n}\n\n.contactListWrapper :global([class*='tdCell']:nth-child(3)),\n.contactListWrapper :global([class*='thCell']:nth-child(3)) {\n  width: 18% !important;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n\n.contactListWrapper :global([class*='tdCell']:nth-child(4)),\n.contactListWrapper :global([class*='thCell']:nth-child(4)) {\n  width: 40% !important;\n  overflow: hidden;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtGrayLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]}`,
	"gtCardHeaderBG": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]}`,
	"borderColor": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]}`,
	"borderColorLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColorLight"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"gtGrayDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtBlueDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]}`,
	"gtBlueLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtGreenLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreenLight"]}`,
	"gtYellowDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]}`,
	"gtYellow": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellow"]}`,
	"gtYellowLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowLight"]}`,
	"text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"section": `styles__section___dvTQa ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"sectionNoMargin": `styles__sectionNoMargin___o8roc ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"card": `styles__card___zwg9j ${___CSS_LOADER_ICSS_IMPORT_1___.locals["card"]}`,
	"cardMarginBot": `styles__cardMarginBot___NNlEX ${___CSS_LOADER_ICSS_IMPORT_1___.locals["cardMarginBot"]}`,
	"sectionSmall": `styles__sectionSmall___SmxOB ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionSmall"]}`,
	"flexRow": `styles__flexRow___r8Cxk ${___CSS_LOADER_ICSS_IMPORT_1___.locals["flexRow"]}`,
	"tableSection": `styles__tableSection___TPRkB styles__section___dvTQa ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"button": `styles__button___Qjsww ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"buttonLocal": `styles__buttonLocal___f2OHz ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonLocal"]}`,
	"buttonSecondary": `styles__buttonSecondary___N1U2_ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonSecondary"]}`,
	"changeInvestmentButton": `styles__changeInvestmentButton___DFRQV ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"resetSSN": `styles__resetSSN___NAgWp styles__buttonSecondary___N1U2_ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonSecondary"]}`,
	"blocks": `styles__blocks___WuQFQ`,
	"block": `styles__block___kI8Wn ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"normal": `styles__normal___E7PdW styles__blocks___WuQFQ`,
	"full": `styles__full___Y8FR2 styles__blocks___WuQFQ`,
	"modal": `styles__modal____Tk9T styles__blocks___WuQFQ`,
	"userInfo": `styles__userInfo___gX9xN styles__block___kI8Wn ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"contactInfo": `styles__contactInfo___twzoJ styles__block___kI8Wn ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"addressInfo": `styles__addressInfo___yWjye styles__block___kI8Wn ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"investmentInfo": `styles__investmentInfo___cWCYs styles__block___kI8Wn ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"relationshipInfo": `styles__relationshipInfo___R2OL6 styles__block___kI8Wn ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"accountsInfo": `styles__accountsInfo___naIwc styles__block___kI8Wn ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"refTitle": `styles__refTitle___pQ3Wl`,
	"refTitleRead": `styles__refTitleRead___bBFbG`,
	"tabTitle": `styles__tabTitle___SWpVe styles__refTitle___pQ3Wl`,
	"openTitle": `styles__openTitle___QxcH2 styles__tabTitle___SWpVe styles__refTitle___pQ3Wl`,
	"closedTitle": `styles__closedTitle___IY8u4 styles__tabTitle___SWpVe styles__refTitle___pQ3Wl`,
	"rejectionTitleWrapper": `styles__rejectionTitleWrapper___cDgEX ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]}`,
	"rejectionTitle": `styles__rejectionTitle___J5nAi`,
	"rejectionBody": `styles__rejectionBody____iwy5 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"row": `styles__row___O8Ee4`,
	"rowGroup": `styles__rowGroup___GW_7r`,
	"rowValue": `styles__rowValue___Uk5fH`,
	"label": `styles__label___ge8IV`,
	"error": `styles__error___p_035`,
	"table": `styles__table___nrX6M`,
	"thRow": `styles__thRow___tTkez`,
	"tdRow": `styles__tdRow___koHQ8`,
	"tdCell": `styles__tdCell____j9TX ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"thCell": `styles__thCell___AkZbv styles__tdCell____j9TX ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"tdDescriptionCell": `styles__tdDescriptionCell___KphYS styles__tdCell____j9TX ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"tableNotes": `styles__tableNotes___kvfJ5`,
	"tableTickets": `styles__tableTickets___LJCny`,
	"docRow": `styles__docRow___yq4ZX styles__row___O8Ee4`,
	"docLink": `styles__docLink___zYxeu`,
	"imageLink": `styles__imageLink___xE_yi`,
	"docLabel": `styles__docLabel___dODaI styles__label___ge8IV`,
	"pending": `styles__pending___AYiAt ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusPending"]}`,
	"incomplete": `styles__incomplete___BI8T1 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusPending"]}`,
	"active": `styles__active___lqSv9 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusActive"]}`,
	"approved": `styles__approved___JZROq ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusActive"]}`,
	"complete": `styles__complete___uShK4 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusActive"]}`,
	"closed": `styles__closed___ncjkD ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusRejected"]}`,
	"rejected": `styles__rejected___i5omP ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusRejected"]}`,
	"tableCollapseWrapper": `styles__tableCollapseWrapper___pphSX`,
	"tableCollapseContent": `styles__tableCollapseContent___clnv4 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"collapseIcon": `styles__collapseIcon___UMvdZ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["collapseIcon"]}`,
	"collapseRef": `styles__collapseRef___pRmxg ${___CSS_LOADER_ICSS_IMPORT_1___.locals["collapseRef"]}`,
	"dropdownArea": `styles__dropdownArea___JPwSF ${___CSS_LOADER_ICSS_IMPORT_1___.locals["dropdownArea"]}`,
	"toggleLabel": `styles__toggleLabel___bQJGG ${___CSS_LOADER_ICSS_IMPORT_1___.locals["toggleLabel"]}`,
	"sectionTitle": `styles__sectionTitle___JwRQV ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"titleSection": `styles__titleSection___TRQrk ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"name": `styles__name___BE21D`,
	"noName": `styles__noName___g4Yp8`,
	"titleSectionLarge": `styles__titleSectionLarge___o7ZFc styles__titleSection___TRQrk ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"titleSectionLargeNM": `styles__titleSectionLargeNM___o7OFR styles__titleSectionLarge___o7ZFc styles__titleSection___TRQrk ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"title": `styles__title___ngYeC`,
	"contactType": `styles__contactType___dmvYj`,
	"relationship": `styles__relationship___G4B2Q`,
	"contactEmailText": `styles__contactEmailText___JBwql`,
	"contactEmailActionButton": `styles__contactEmailActionButton___OuRXK`,
	"refEdit": `styles__refEdit___bH3lY`,
	"refEditSmall": `styles__refEditSmall___UAdl6 styles__refEdit___bH3lY`,
	"noDocResults": `styles__noDocResults___tOqT8 styles__sectionNoMargin___o8roc ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"editLink": `styles__editLink___TGppv`,
	"dodLink": `styles__dodLink___Gkdiw`,
	"dateStyle": `styles__dateStyle___FN8SS`,
	"dateStyleClosed": `styles__dateStyleClosed___XJ2Vo styles__dateStyle___FN8SS`,
	"dateTitle": `styles__dateTitle___cUjv9 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]}`,
	"dateStyleClosing": `styles__dateStyleClosing___d3uTn styles__dateStyle___FN8SS`,
	"dateStyleActive": `styles__dateStyleActive___wjAh6 styles__dateStyle___FN8SS`,
	"dateStylePending": `styles__dateStylePending___hKDTO styles__dateStyle___FN8SS`,
	"dateStyleSuspended": `styles__dateStyleSuspended___WB63b styles__dateStyle___FN8SS`,
	"accountInfo": `styles__accountInfo___Rn1eH ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]}`,
	"lastUpdated": `styles__lastUpdated___fEtoh`,
	"checkIcon": `styles__checkIcon___rDUZJ`,
	"timesIcon": `styles__timesIcon___oOU8W`,
	"dateInformation": `styles__dateInformation___jXxvV styles__sectionNoMargin___o8roc ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"dateInfoPending": `styles__dateInfoPending___JrGBL styles__dateInformation___jXxvV styles__sectionNoMargin___o8roc ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"dateInfoOpen": `styles__dateInfoOpen___ixRWQ styles__dateInfoPending___JrGBL styles__dateInformation___jXxvV styles__sectionNoMargin___o8roc ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"dateInfoClosed": `styles__dateInfoClosed___GoYpr styles__dateInfoPending___JrGBL styles__dateInformation___jXxvV styles__sectionNoMargin___o8roc ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"dateInfoClosing": `styles__dateInfoClosing___nG_5I styles__dateInfoPending___JrGBL styles__dateInformation___jXxvV styles__sectionNoMargin___o8roc ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"fileName": `styles__fileName___rV9IU`,
	"accountExtrasSection": `styles__accountExtrasSection___O9VPL styles__sectionNoMargin___o8roc ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"singleLine": `styles__singleLine___y9opj`,
	"rowError": `styles__rowError____qZkl styles__row___O8Ee4`,
	"value": `styles__value___TOakx`,
	"valueMono": `styles__valueMono___nWWmi styles__value___TOakx`,
	"valueBlank": `styles__valueBlank___HSch3 styles__value___TOakx`,
	"valueBold": `styles__valueBold___sw6SU styles__value___TOakx`,
	"valueAlert": `styles__valueAlert___fOJbR styles__value___TOakx`,
	"noResults": `styles__noResults___CB4bl ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"notesSection": `styles__notesSection____D_5Y styles__section___dvTQa ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"formRefContent": `styles__formRefContent___NTnr_`,
	"formRefSection": `styles__formRefSection___O1xcg`,
	"contactBasicFormRef": `styles__contactBasicFormRef___a0SRH`,
	"formRefButtons": `styles__formRefButtons___VuCG8`,
	"basicEdit": `styles__basicEdit___WL2_m`,
	"ticketFlag": `styles__ticketFlag___z7OLh`,
	"ticketFlagSmall": `styles__ticketFlagSmall___QxIrr`,
	"buttons": `styles__buttons___K_f15 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"removeBtn": `styles__removeBtn___X1a6g ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonDanger"]}`,
	"cancelBtn": `styles__cancelBtn___oEOfV ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"docsWrapper": `styles__docsWrapper___L7pYM ${___CSS_LOADER_ICSS_IMPORT_1___.locals["flexColumn"]}`,
	"otherDocsRow": `styles__otherDocsRow___ZBgdx`,
	"remove": `styles__remove___bC2YH`,
	"select": `styles__select___qWiFF ${___CSS_LOADER_ICSS_IMPORT_1___.locals["select"]}`,
	"spacer": `styles__spacer___L79sN`,
	"globalErrors": `styles__globalErrors___kqAwm styles__error___p_035`,
	"oneHalf": `styles__oneHalf___iwu2p`,
	"flexFlow": `styles__flexFlow___T2DHT ${___CSS_LOADER_ICSS_IMPORT_1___.locals["flexRow"]}`,
	"metric": `styles__metric___oQhge`,
	"receiptButton": `styles__receiptButton___ZPMl_`,
	"infoButton": `styles__infoButton___S7e82`,
	"input": `styles__input___MfLX9 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["input"]}`,
	"formItemMono": `styles__formItemMono___bcb3G ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItemMono"]}`,
	"balanceRefHeader": `styles__balanceRefHeader___bExfc`,
	"addSubaccountButton": `styles__addSubaccountButton___IQjfh`,
	"addSubaccountIcon": `styles__addSubaccountIcon___FWCNR`,
	"singleLineValue": `styles__singleLineValue___Byjo0`,
	"contactListPhone": `styles__contactListPhone___zSd7h`,
	"contactListWrapper": `styles__contactListWrapper___nLKlo`
};
export default ___CSS_LOADER_EXPORT___;
